import { createFileRoute } from '@tanstack/react-router';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { SettlementStatisticsConverterDetailSummaryPage } from '@/pages/settlement-statistics-converter/ui/SettlementStatisticsConverterDetailSummaryPage';

/**
 * 決算統計コンバーター結果詳細ルート（サマリータブ）
 */
export const Route = createFileRoute('/_protected/settlement-statistics-converter/$resultId/')({
  component: () => <SettlementStatisticsConverterDetailSummaryPage />,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
});
